// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svgIcon_I05jWBfp {\n  display: block;\n}\n", "",{"version":3,"sources":["webpack://./public/uiComponents/uikit/VueIcon/styles/svgSprite.less"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".svgIcon {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svgIcon": "svgIcon_I05jWBfp"
};
export default ___CSS_LOADER_EXPORT___;
